<template>
  <aside
    class="explore-more-module"
    v-if="data && data.length > 0 && !isMobile"
    :data-metrics-module="discoverax"
    v-metric="{ module: 'discoverax' }"
  >
    <header>
      <h3>Explore More On {{ topicName }}</h3>
    </header>

    <ul :class="{twocolumns: twoColumns}">
      <li
        v-for="(item, index) in data"
        :key="index"
        :style="getDisplayStyle(index)"
      >
        <div class="card" v-if="item.title" v-metric="{ module: 'discoverax' }">
          <div class="container">
             <div class="title-container"><a class="title" v-metric="{link: (index+1)}" :href="item.url">{{ item.title }} </a> </div>
            <div class="med-rev-section">
              <div class="reviewer-photo-cont" v-if="item.reviewer && item.reviewer.imagePath">
                <img
                  :src="item.reviewer.imagePath"
                  class="reviewer-photo"
                />
              </div>

              <div class="med-rev-content" v-metric="{ module: 'discoverax' }">
                <span class="rev-info"
                  >{{ translation('Medically reviewed by') }}
                  <a
                    v-if="item.reviewer
						&& item.reviewer.name
						&& item.reviewer.bio"
                    v-metric="{link: 'medrev'}"
                    :href="item.reviewer.bio"
                    >{{ item.reviewer.name }}</a
                  >
                  <span
                    class="no-link"
                    v-else-if="item.reviewer && item.reviewer.name && !item.reviewer.bio"
                  >
                    {{ item.reviewer.name }}
                  </span>

                  <span> {{ item.reviewer.reviewDate }}</span>
                </span>
                <span
                  v-if="item.authors && Object.keys(item.authors).length > 0"
                >
                  {{ translation('Written by') }}
                  <span v-for="(author, index) in item.authors">
                    <span v-if="!author.bio"> {{ author.name }} </span>
                    <a
                      v-else
                      v-metric="{link: 'write'}"
                      :href="author.bio"
                    >
                    {{ translation(author.name) }}
                    </a>
                    <span v-if="index < item.authors.length - 1">, </span>
                  </span>
                </span>
                <span v-else>
                  {{ translation('Written by') }}
                  <a
                    href="https://www.webmd.com/webmd-editorial-contributors"
                    v-metric="{ mlink: 'wrtnbyeditlnk'}"
                  >
                    {{ translation('WebMD Editorial Contributors') }}
                  </a>
                </span>
              </div>
            </div>

            <p class="desc">{{ item.description }}</p>

              <a class="cta" :href="item.url" v-metric="{link: (index+1)}"> {{ translation('View now') }} </a>
            
          </div>
        </div>
      </li>
    </ul>

    <div class="toggle-button-container" v-if="data.length > 2">
      <button
        class="toggle-button"
        @click="toggleShowMore"
        :class="{ 'show-less': showMore }"
      >
        {{ showMore ? 'Show Less' : 'Show More' }}
        <i class="webmd-icon-down-arrow"></i>
      </button>
    </div>
  </aside>
</template>

<script>

import useStore from 'webmd-cms-store/src/store';
import axios from 'axios';
import getEnvStore from 'webmd-cms-store/src/store/helpers/utils.es6';
import shuffle from 'lodash/shuffle';
import { getTranslationData } from './helpers/translations.es6';

export default {
  data() {
    return {
      // msg: 'This is a vue Page',
      data: [],
      showMore: true,
      twoColumns: true,
      isMobile: false,
      showMore: false,
      topicName: '',
      localLang: '',

    };
  },

  components: {
    // ExampleSubComponent,

  },

  props: {

  },


  methods: {
    async fetchData() {
      try {
        const self = this;
        const topicVal = self.store.pagedata.omniture.s_topic;
        const assetIdVal = self.store.pagedata.omniture.s_asset_id;
        const urlDomain = window.location.host.toLowerCase();
        const domainUrl = getEnvStore.getEnvironment(urlDomain).servicedomain;
        const apiUrl = `${domainUrl}/kapi/popular?topic=${topicVal}&expand=true&lang=${this.localLang}` || '';

        const response = await axios.get(apiUrl);
        const responsedataObj = response.data;

        const key = 'assetId';
        let dataObj = [...new Map(responsedataObj.map((item) => [item[key], item])).values()];
        if (dataObj) {
          const topicName = dataObj?.[0]?.topicName;
          const sensitivePhrase = "(sensitive topic)";
          this.topicName = this.removeSensitiveTopic(topicName, sensitivePhrase);
          dataObj = shuffle(dataObj);
          const result = dataObj
            .filter((item) => item.assetId !== assetIdVal && item.url)
            .map((item) => {
              return {
                title: item.title,
                description: item.description,
                url: item.url,
                reviewer: {
                  name: item.reviewer.name,
                  bio: item.reviewer.bio,
                  reviewDate: this.formatDate(item.lastReviewDate),
                  imagePath: this.getReviewerImage(item.reviewer.imagePath),
                },
                authors: item.authors.map((author) => {
                  return {
                    name: author.name,
                    bio: author.bio,
                  };
                }),
              };
            });
          return result;
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    removeSensitiveTopic(topicName, sensitivePhrase) {
      if (!topicName) return '';
      const regex = new RegExp(sensitivePhrase.replace(/[()]/g, '\\$&'), 'i');
      return topicName.replace(regex, '').trim();
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const monthNames = [
        'January', 'February', 'March',
        'April', 'May', 'June', 'July',
        'August', 'September', 'October',
        'November', 'December',
      ];

      let day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();

      day = (day > 9) ? day : (`0${day}`);
      this.formattedDate = monthNames[monthIndex] && day && year && ` on ${monthNames[monthIndex]} ${day}, ${year}`;
      if (this.localLang === 'es_ES') {
        this.formattedDate = ` en ${this.translation(monthNames[monthIndex])} ${day} del ${year}`;
      }

      return this.formattedDate;
    },


    toggleShowMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.$vwmdPageLink('discovmore');
      }

    },

    getDisplayStyle(index) {
      return { display: this.showMore ? 'flex' : (index < 2 ? 'flex' : 'none') };
    },

    getReviewerImage(imagePath) {

      const imageBaseUrl = this.store?.pagedata?.omniture?.image_server_url;
      const reviewerImg = imagePath && imageBaseUrl
        ? `${imageBaseUrl}${imagePath}?resize=51px:51px&output-quality=75`
        : 'https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/Avatar.svg';

      return reviewerImg;

    },

    translation(text) {
      return getTranslationData(this.localLang , text) || text; 
    },


  },

  mounted() {
    this.isMobile = window.matchMedia("(max-width: 466px)").matches;
    this.store = useStore(this.$pinia);
    this.localLang = this.store?.pagedata?.omniture?.s_language_locale || 'en_US';
    this.fetchData().then((data) => {
      this.data = data;
    }).catch((error) => {
      console.error(error);
    });
  },
};
</script>


<style lang="scss" src="./stylesheets/component.scss">
</style>